import { C2A } from '../../constants/constants'
import { updateObject } from '../../helpers/util'

const initialState = {
  C2ATemplatesList: [],
  C2ATemplatesLoading: false,
  C2ATemplatesError: null
  //
}

export default function C2AReducer(state = initialState, action) {
  switch (action.type) {
    case C2A.SET_C2A_TEMPLATES:
      return updateObject(state, {
        C2ATemplatesList: action.payload,
        C2ATemplatesLoading: false,
        C2ATemplatesError: null
      })

    case C2A.SET_C2A_TEMPLATES_LOADER:
      return updateObject(state, {
        C2ATemplatesLoading: action.payload,
        C2ATemplatesError: null
      })
    case C2A.SET_C2A_TEMPLATES_ERROR:
      return updateObject(state, {
        C2ATemplatesLoading: false,
        C2ATemplatesError: action.payload
      })

    default:
      return state
  }
}
